import { useEffect } from "react";
import { BRAND } from "../../mock";

export const WHATSAPP_URL = "https://wa.me/16193176858";

function WhatsAppIcon() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      style={{ flexShrink: 0 }}
    >
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
    </svg>
  );
}

// Landing post-checkout: sin header/footer pesados, solo wordmark + tarjeta.
// Marca la página como noindex mientras está montada (reutiliza la meta
// robots que ya existe en index.html y la restaura al desmontar).
export default function PostCheckout({ eyebrow, title, body, orderId, pageTitle }) {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = pageTitle;

    let meta = document.querySelector('meta[name="robots"]');
    const created = !meta;
    const prevContent = meta ? meta.getAttribute("content") : null;
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "robots");
      document.head.appendChild(meta);
    }
    meta.setAttribute("content", "noindex, nofollow");

    return () => {
      document.title = prevTitle;
      if (created) meta.remove();
      else meta.setAttribute("content", prevContent ?? "index, follow");
    };
  }, [pageTitle]);

  return (
    <main
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "40px 20px",
        background: "var(--bg)",
        fontFamily: '"DM Sans", system-ui, sans-serif',
        color: "var(--ink)",
      }}
    >
      <div style={{ width: "100%", maxWidth: 520 }}>
        {/* Wordmark — mismo estilo que el brand del Header */}
        <div style={{ textAlign: "center", marginBottom: 32 }}>
          <a
            href="/"
            style={{
              fontFamily: '"DM Sans", sans-serif',
              fontSize: 13,
              fontWeight: 600,
              letterSpacing: "0.04em",
              textTransform: "uppercase",
              color: "var(--ink)",
              textDecoration: "none",
            }}
          >
            {BRAND.channel}
          </a>
        </div>

        <section
          style={{
            background: "rgba(255,255,255,0.55)",
            border: "1px solid var(--line)",
            borderRadius: 18,
            padding: "clamp(28px, 6vw, 44px)",
            textAlign: "center",
          }}
        >
          <div className="eyebrow" style={{ marginBottom: 18 }}>
            {eyebrow}
          </div>

          <h1
            className="font-display"
            style={{
              fontSize: "clamp(2rem, 6vw, 2.8rem)",
              fontWeight: 500,
              letterSpacing: "-0.02em",
              lineHeight: 1.08,
              margin: "0 0 16px",
            }}
          >
            {title}
          </h1>

          <p
            style={{
              fontSize: 16,
              lineHeight: 1.6,
              color: "var(--ink-dim)",
              margin: "0 auto 24px",
              maxWidth: 420,
            }}
          >
            {body}
          </p>

          {orderId ? (
            <div
              aria-label={`Número de pedido ${orderId}`}
              style={{
                display: "inline-block",
                background: "rgba(17,17,16,0.06)",
                border: "1px solid var(--line)",
                borderRadius: 100,
                padding: "8px 16px",
                fontSize: 14,
                fontWeight: 600,
                letterSpacing: "0.04em",
                color: "var(--ink)",
                marginBottom: 28,
              }}
            >
              Pedido #{orderId}
            </div>
          ) : (
            <div style={{ height: 4 }} />
          )}

          <div>
            <a
              href={WHATSAPP_URL}
              className="btn-whatsapp pc-cta"
              style={{ padding: "14px 28px", fontSize: 15 }}
            >
              <WhatsAppIcon />
              Volver a WhatsApp
            </a>
          </div>
        </section>
      </div>

      <style>{`
        @media (max-width: 480px) {
          .pc-cta {
            width: 100%;
            justify-content: center;
          }
        }
      `}</style>
    </main>
  );
}
